import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import GeckoDate from 'services/gecko-date';

import { GECKO_CONSTS, GECKO_UTILS } from 'ui';

import EditableValueField from './field.jsx';

class EditableValue extends Component {
  static propTypes = {
    field: PropTypes.object.isRequired,
    values: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      editting: false,
      originalValue: props.values[props.field.key],
    };
  }

  editValuesMap = {
    [GECKO_CONSTS.FIELD_TYPE_ADDRESS]: (
      <span className="EditableValue-placeholder">
        Add an address <i className="far fa-edit"></i>
      </span>
    ),
    [GECKO_CONSTS.FIELD_TYPE_DATE]: (
      <span className="EditableValue-placeholder">
        Enter date <i className="far fa-calendar-alt"></i>
      </span>
    ),
    [GECKO_CONSTS.FIELD_TYPE_EMAIL]: (
      <span className="EditableValue-placeholder">
        Add an email address<i className="far fa-edit"></i>
      </span>
    ),
    [GECKO_CONSTS.FIELD_TYPE_NAME]: (
      <span className="EditableValue-placeholder">
        Add name <i className="far fa-edit"></i>
      </span>
    ),
    [GECKO_CONSTS.FIELD_TYPE_NUMBER]: (
      <span className="EditableValue-placeholder">
        Enter value <i className="far fa-edit"></i>
      </span>
    ),
    [GECKO_CONSTS.FIELD_TYPE_SELECT]: (
      <span className="EditableValue-placeholder">
        Pick value <i className="fas fa-caret-down"></i>
      </span>
    ),
    [GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI]: (
      <span className="EditableValue-placeholder">
        Pick value <i className="fas fa-caret-down"></i>
      </span>
    ),
    [GECKO_CONSTS.FIELD_TYPE_TELEPHONE]: (
      <span className="EditableValue-placeholder">
        Add a phone number <i className="far fa-edit"></i>
      </span>
    ),
    [GECKO_CONSTS.FIELD_TYPE_CUSTOM]: (
      <span className="EditableValue-placeholder">
        Add a phone number <i className="far fa-edit"></i>
      </span>
    ),
    [GECKO_CONSTS.FIELD_TYPE_TEXT]: (
      <span className="EditableValue-placeholder">
        Enter value <i className="far fa-edit"></i>
      </span>
    ),
    [GECKO_CONSTS.FIELD_TYPE_TEXTAREA]: (
      <span className="EditableValue-placeholder">
        Enter value <i className="far fa-edit"></i>
      </span>
    ),
    display: (
      <span className="EditableValue-placeholder display-field">
        View <i className="far fa-eye"></i>
      </span>
    ),
  };

  iconMap = {
    full_name: 'far fa-user',
    first_name: 'far fa-user',
    last_name: 'far fa-user',
    email: 'far fa-envelope',
    tel: 'far fa-phone',
  };

  iconTypeMap = {
    [GECKO_CONSTS.FIELD_TYPE_ADDRESS]: 'far fa-info',
    [GECKO_CONSTS.FIELD_TYPE_DATE]: 'far fa-calendar-alt',
    [GECKO_CONSTS.FIELD_TYPE_EMAIL]: 'far fa-envelope',
    [GECKO_CONSTS.FIELD_TYPE_NAME]: 'far fa-user',
    [GECKO_CONSTS.FIELD_TYPE_NUMBER]: 'far fa-info',
    [GECKO_CONSTS.FIELD_TYPE_SELECT]: 'far fa-info',
    [GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI]: 'far fa-info',
    [GECKO_CONSTS.FIELD_TYPE_CUSTOM]: 'far fa-phone',
    [GECKO_CONSTS.FIELD_TYPE_TELEPHONE]: 'far fa-phone',
    display: 'far fa-align-left',
    [GECKO_CONSTS.FIELD_TYPE_TEXT]: 'far fa-info',
    [GECKO_CONSTS.FIELD_TYPE_TEXTAREA]: 'far fa-info',
  };

  startEditting() {
    if (!this.state.editting) {
      this.setState({ editting: true });
    }
  }

  stopEditting() {
    this.setState({ editting: false });
  }

  isEllipsisActive(elem) {
    return elem.offsetWidth < elem.scrollWidth;
  }

  ellipsesize(elem, value) {
    if (this.isEllipsisActive(elem)) {
      const newValue = value.slice(0, -1);
      elem.textContent = newValue;
      this.ellipsesize(elem, newValue);
    } else {
      elem.textContent = value.slice(0, -3) + '...';
    }
  }

  componentDidMount() {
    if (this.valueElem && this.isEllipsisActive(this.valueElem)) {
      this.ellipsesize(this.valueElem, this.valueElem.textContent);
    }
  }

  componentDidUpdate() {
    if (this.valueElem && this.isEllipsisActive(this.valueElem)) {
      this.ellipsesize(this.valueElem, this.valueElem.textContent);
    }
  }

  getOptionFromValue([option, ...rest], value) {
    if (!option) {
      return null;
    }
    if (option.options) {
      const foundOption = this.getOptionFromValue(option.options, value);
      if (foundOption) {
        return foundOption;
      }
    }
    if (option.value === value) {
      return option;
    }
    return this.getOptionFromValue(rest, value);
  }

  render() {
    const rawValue = GECKO_UTILS.getNestedValue(
      this.props.values,
      this.props.field.key
    );
    let value = rawValue;
    if (rawValue && this.props.field.type === GECKO_CONSTS.FIELD_TYPE_SELECT) {
      const element = this.getOptionFromValue(
        this.props.field.options,
        rawValue
      );
      value = element ? element.label : undefined;
    }
    if (
      rawValue &&
      this.props.field.type === GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI
    ) {
      value = rawValue
        .filter(
          (val) =>
            !(
              val === null ||
              val === undefined ||
              this.getOptionFromValue(this.props.field.options, val) === null
            )
        )
        .map(
          (val) => this.getOptionFromValue(this.props.field.options, val).label
        )
        .join(', ');
    }
    if (rawValue && this.props.field.type === GECKO_CONSTS.FIELD_TYPE_DATE) {
      value = new GeckoDate(value, 'X', { enableUTC: true }).SHORT;
    }

    const icon =
      this.iconMap[this.props.field.key] ||
      this.iconTypeMap[this.props.field._type] ||
      'fa-info';
    const editableField =
      this.props.field._type === 'display' ? (
        <EditableValueField
          field={this.props.field}
          values={this.props.values}
          stopEditting={this.stopEditting.bind(this)}
        />
      ) : (
        <EditableValueField
          field={this.props.field}
          values={this.props.values}
          stopEditting={this.stopEditting.bind(this)}
          submitValue={this.props.onChange}
        />
      );
    return (
      <div className="EditableValue">
        <div
          className="EditableValue-container d-flex align-items-center"
          onClick={this.startEditting.bind(this)}
        >
          <span className="EditableValue-label col-4">{this.props.field.label}:</span>
          {value ? (
            <span
              className="EditableValue-value col"
              ref={(elem) => (this.valueElem = elem)}
            >
              {value}
            </span>
          ) : (
            <span className="EditableValue-value col">
              {this.editValuesMap[this.props.field._type]}
            </span>
          )}
        </div>
        {this.state.editting ? editableField : null}
      </div>
    );
  }
}

export default EditableValue;
